/* Eznzza · "Completá tu rutina" (snippets/complementary-products.liquid y cyr-card.liquid).
   rhode-cyr: check por producto, selector de tono/tamaño y "Agregar — $total".
   Sin complementarios cargados: productos de la misma marca (sections/cyr-fallback.liquid). */
(function () {
  if (customElements.get('rhode-cyr')) return;
  /* Estado "Agregado" del botón y aviso de confirmación */
  var st = document.createElement('style');
  st.textContent =
    '.cyr-actions .cyr-add.is-done,.cyr-actions .cyr-add.is-done:disabled{background:#670001;color:#F2EFED;opacity:1;cursor:default}' +
    '.cyr-error.is-ok{color:#670001;font-weight:600}';
  document.head.appendChild(st);
  function money(cents) {
    var n = Math.round(cents) / 100;
    return '$' + n.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  class RhodeCyr extends HTMLElement {
    connectedCallback() {
      this.btn = this.querySelector('[data-cyr-add]');
      this.btnLabel = this.querySelector('[data-cyr-add-label]');
      this.error = this.querySelector('[data-cyr-error]');
      this.querySelectorAll('[data-cyr-card]').forEach((card) => {
        const check = card.querySelector('[data-cyr-check]');
        const sel = card.querySelector('[data-cyr-select]');
        if (check) check.addEventListener('change', () => {
          card.classList.toggle('is-checked', check.checked);
          this.update();
        });
        if (sel && check) {
          sel.addEventListener('change', () => {
            const opt = sel.options[sel.selectedIndex];
            check.value = opt.value;
            check.dataset.price = opt.dataset.price;
            const price = card.querySelector('[data-cyr-price]');
            if (price) price.textContent = money(Number(opt.dataset.price));
            const img = card.querySelector('[data-cyr-img]');
            if (img && opt.dataset.img) img.src = opt.dataset.img;
            this.update();
          });
        }
      });
      if (this.btn) this.btn.addEventListener('click', () => this.add());
      this.update();
    }
    /* Confirmación en el botón: "Agregado ✓" y un aviso debajo */
    done(n) {
      clearTimeout(this._doneT);
      this.btn.classList.add('is-done');
      this.btn.disabled = true;
      this.btnLabel.textContent = n > 1 ? 'Agregados ✓' : 'Agregado ✓';
      if (this.error) {
        this.error.textContent = (n > 1 ? 'Se agregaron ' + n + ' productos' : 'Se agregó 1 producto') + ' a tu carrito.';
        this.error.classList.add('is-ok');
        this.error.hidden = false;
      }
      this._doneT = setTimeout(() => {
        this.btn.classList.remove('is-done');
        if (this.error) { this.error.hidden = true; this.error.classList.remove('is-ok'); }
        this.update();
      }, 2600);
    }
    checked() {
      return Array.from(this.querySelectorAll('[data-cyr-check]:checked'));
    }
    update() {
      if (this.btn && this.btn.classList.contains('is-done') && this.checked().length === 0) return;
      clearTimeout(this._doneT);
      if (this.btn) this.btn.classList.remove('is-done');
      if (this.error) this.error.classList.remove('is-ok');
      const items = this.checked();
      const total = items.reduce((t, c) => t + Number(c.dataset.price || 0), 0);
      this.btn.disabled = items.length === 0;
      this.btnLabel.textContent = items.length ? 'Agregar — ' + money(total) : 'Elegí productos';
      if (this.error) this.error.hidden = true;
    }
    async add() {
      const items = this.checked();
      if (!items.length) return;
      this.btn.classList.add('is-loading');
      const body = new FormData();
      items.forEach((c, i) => {
        body.append('items[' + i + '][id]', c.value);
        body.append('items[' + i + '][quantity]', '1');
      });
      const cart = document.querySelector('cart-drawer');
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.append('sections', cart.getSectionsToRender().map((s) => s.id));
        body.append('sections_url', window.location.pathname);
      }
      const addUrl = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
      try {
        const res = await fetch(addUrl, { method: 'POST', body: body, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
        const data = await res.json();
        if (data.status) {
          if (this.error) { this.error.textContent = data.description || data.message || 'No se pudo agregar al carrito.'; this.error.hidden = false; }
          return;
        }
        if (!cart || typeof cart.renderContents !== 'function') {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'rhode-cyr' });
        }
        /* Actualiza el carrito (contenido y contador) sin abrirlo: la clienta
           sigue en la ficha para elegir y agregar el producto principal */
        cart.renderContents(data);
        cart.classList.remove('is-empty');
        items.forEach((c) => { c.checked = false; c.closest('[data-cyr-card]').classList.remove('is-checked'); });
        this.update();
        this.done(items.length);
      } catch (e) {
        console.error(e);
      } finally {
        this.btn.classList.remove('is-loading');
      }
    }
  }
  customElements.define('rhode-cyr', RhodeCyr);
})();
/* Sin complementarios cargados: productos de la misma marca, de otra
   categoría (sections/cyr-fallback.liquid, via la búsqueda de la tienda) */
(function () {
  if (window.__cyrFallback) return;
  window.__cyrFallback = true;
  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
  function norm(s) { return (s || '').toLowerCase().trim(); }
  async function fill(el) {
    var brand = el.dataset.cyrBrand;
    if (!brand || el.querySelector('[data-cyr-card]')) return;
    try {
      var own = await fetch(el.dataset.url).then(function (r) { return r.text(); });
      var ownBox = new DOMParser().parseFromString(own, 'text/html');
      var ownRec = ownBox.querySelector('recommendations-product');
      if (ownRec && ownRec.querySelector('[data-cyr-card]')) return; /* tiene complementarios: los pone el tema */
      var url = '/search?q=' + encodeURIComponent(brand) + '&type=product&options%5Bprefix%5D=last&section_id=cyr-fallback';
      var html = await fetch(url).then(function (r) { return r.text(); });
      if (el.querySelector('[data-cyr-card]')) return;
      var box = new DOMParser().parseFromString(html, 'text/html');
      var b = norm(brand), pid = el.dataset.cyrPid, type = norm(el.dataset.cyrType);
      var seen = {}, cards = [];
      box.querySelectorAll('[data-cyr-card]').forEach(function (c) {
        if (c.dataset.pid === pid || seen[c.dataset.pid]) return;
        if (norm(c.dataset.vendor) !== b && norm(c.dataset.title).indexOf(b) !== 0) return;
        seen[c.dataset.pid] = true;
        cards.push(c);
      });
      if (!cards.length) return;
      var limit = parseInt(el.dataset.cyrLimit, 10) || 3;
      var picks = [], types = {};
      /* 1) otra categoría, sin repetir  2) otra categoría  3) lo que quede */
      [function (c) { var t = norm(c.dataset.type); return t !== type && !types[t]; },
       function (c) { return norm(c.dataset.type) !== type; },
       function () { return true; }].forEach(function (ok) {
        cards.forEach(function (c) {
          if (picks.length >= limit || picks.indexOf(c) !== -1 || !ok(c)) return;
          picks.push(c);
          types[norm(c.dataset.type)] = true;
        });
      });
      var heading = el.dataset.cyrHeading;
      el.innerHTML =
        '<rhode-cyr class="cyr-wrap">' +
        (heading ? '<div class="cyr-heading">' + esc(heading) + '</div>' : '') +
        '<div class="cyr-grid">' + picks.map(function (c) { return c.outerHTML; }).join('') + '</div>' +
        '<div class="cyr-actions"><p class="cyr-error" data-cyr-error hidden></p>' +
        '<button type="button" class="cyr-add" data-cyr-add disabled><span data-cyr-add-label>Elegí productos</span></button></div>' +
        '</rhode-cyr>';
    } catch (e) {
      console.error(e);
    }
  }
  function init() {
    document.querySelectorAll('recommendations-product.cyr[data-cyr-brand]').forEach(function (el) {
      if (el.__cyrObs) return;
      el.__cyrObs = true;
      if (!('IntersectionObserver' in window)) { fill(el); return; }
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        fill(el);
      }, { rootMargin: '0px 0px 400px 0px' });
      io.observe(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
